import React from "react";
import { useParams } from "react-router";
import { mediaService } from "../../../../../Core/Api/services";
import { SetFetchedMediaFiles } from "../../../../../Redux/Reducers/redux-slice-asset";
import { useAppDispatch } from "../../../../../Redux/redux-store";
import AssetSingleMediaFilesContent from "./asset-single-media-files-content";

function AssetSingleMediaFiles() {
  const { id } = useParams();
  const dispatch = useAppDispatch();

  const refreshMediaFiles = () => {
    mediaService.GetFilesByObjectId(Number(id)).then(function (response) {
      dispatch(SetFetchedMediaFiles(response.files || []));
    });
  };

  React.useEffect(() => {
    refreshMediaFiles();
  }, [id]);

  return <AssetSingleMediaFilesContent refreshMediaFiles={refreshMediaFiles} />;
}

export default AssetSingleMediaFiles;
